import { render, staticRenderFns } from "./FormBooking.vue?vue&type=template&id=0e64dd64"
import script from "./FormBooking.vue?vue&type=script&lang=js"
export * from "./FormBooking.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports